const gqlConditionalString = (value, key) => {
  if (value) return `${key}: "${value}",`;
  return ''
};

export default gqlConditionalString;
